// Unpublished Work © 2026 Deere & Company.

import React from 'react';
import {SupportedLanguages} from '../../constants/supported-languages';

function getBadgePath(platform: string, language: string): string {
    let badgePath: string;

    if (platform === 'ios') {
        badgePath = `apple-badge-${language}`;
    } else {
        badgePath = `google-play-badge-${language}`;
    }

    if (!SupportedLanguages.includes(language)) {
        badgePath = platform === 'ios' ? 'apple-badge-en' : 'google-play-badge-en';
    }

    return badgePath;
}

interface StoreBadgeProps {
    platform: string;
    url: string;
    onClick?: React.MouseEventHandler<HTMLAnchorElement>;
}

export function StoreBadge({platform, url, onClick}: StoreBadgeProps) {
    const languageCode = navigator?.language?.split('-')?.[0] || 'en';
    const iosBadge = getBadgePath('ios', languageCode);
    const androidBadge = getBadgePath('android', languageCode);

    let image;
    const badgeWidth = platform === 'ios' ? 96 : 108;
    if (platform === 'ios') {
        image = `/assets/${iosBadge}.svg`;
    } else {
        image = `/assets/${androidBadge}.svg`;
    }

    return (
        <a href={url} target='_blank' rel='noopener noreferrer' onClick={onClick}>
            <img
                alt={`${platform === 'ios' ? 'Apple' : 'Google Play'} Store badge`}
                src={image}
                width={badgeWidth}
                height={32}
            />
        </a>
    );
}
